import { DialogRoot, DialogCustomContent } from "./DialogGeneric.styles";
import { useTheme } from "@mui/material";

export const DialogGeneric = (props) => {
  const { show, close, onHandleClose, maxWidth, children } = props;
  const theme = useTheme();

  return (
    <DialogRoot
      fullWidth
      maxWidth={maxWidth}
      open={show}
      onClose={() => onHandleClose(false, "backdropClick")}
      sx={{
        "& .MuiBackdrop-root": {
          background: "rgba(194, 194, 194, 0.1)",
          backdropFilter: "blur(0.5rem)",
          "&::after": {
            content: "''",
            width: "100%",
            height: "50vh",
            position: "absolute",
            bottom: 0,
            left: 0,
            zIndex: -1,
            background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 130%)",
            opacity: 0.7,
            transition: "all 0.3s ease-out",
          },
        },
      }}
    >
      <DialogCustomContent>
        {children}
      </DialogCustomContent>
    </DialogRoot>
  );
};
